<div class="header-bar" style="display: flex; justify-content: space-between">
  <h1>Vehicle LifeCycle</h1>
  <div class="style2023 mt-2">
    <button
      type="button"
      pButton
      icon="{{ !isDownloading ? 'fa ui-icon-file-download' : 'fa fa-spin fa-circle-o-notch' }}"
      label="{{ !isDownloading ? 'Download CSV' : 'Downloading' }}"
      class="button-style btn-md ui-tertiary-button"
      (click)="downloadReport()"
      [disabled]="isDownloading"
    ></button>
  </div>
</div>
<div class="content-container">
  <div class="vehicle-status-parent-container">
    <div class="vehicle-status-overview-container">
      <div class="vehicle-status-overview-heading">
        <h2>Vehicle Status Overview</h2>
        <span class="last-updated-time"
          >Last Updated
          {{
            overviewCounts?.lastRefreshDate == null
              ? 'N/A'
              : (overviewCounts?.lastRefreshDate | date : 'hh:mm a')
          }}</span
        >
      </div>
      <div class="vehicle-status-overview-cards">
        <div class="status-card" (click)="selectTile(['ONROUTE'])">
          <div class="inner-card">
            <div class="icon">
              <img src="{{ getStatusIconUrl('en-route') }}" />
            </div>
            <div class="number">{{ overviewCounts?.enRouteCount ?? 0 }}</div>
            <div class="label">Vehicles</div>
            <div class="status" [pTooltip]="getStatusWidgetDescription('en-route')">En Route</div>
          </div>
        </div>
        <div class="status-card" (click)="selectTile(['CHECKEDIN'])">
          <div class="inner-card">
            <div class="icon">
              <img src="{{ getStatusIconUrl('checked-in') }}" />
            </div>
            <div class="number">{{ overviewCounts?.checkedInCount ?? 0 }}</div>
            <div class="label">Vehicles</div>
            <div class="status" [pTooltip]="getStatusWidgetDescription('checked-in')">
              Checked In
            </div>
          </div>
        </div>
        <div class="status-card" (click)="selectTile(['ESTIMATED', 'RE-ESTIMATEREQUIRED'])">
          <div class="inner-card">
            <div class="icon">
              <img src="{{ getStatusIconUrl('pending-estimate') }}" />
            </div>
            <div class="number">{{ overviewCounts?.pendingEstimateCount ?? 0 }}</div>
            <div class="label">Vehicles</div>
            <div class="status" [pTooltip]="getStatusWidgetDescription('pending-estimate')">
              Pending Estimate
            </div>
          </div>
        </div>
        <div class="status-card" (click)="selectTile(['INPROCESS'])">
          <div class="inner-card">
            <div class="icon">
              <img src="{{ getStatusIconUrl('refurb-progress') }}" />
            </div>
            <div class="number">{{ overviewCounts?.refurbInProgressCount ?? 0 }}</div>
            <div class="label">Vehicles</div>
            <div class="status" [pTooltip]="getStatusWidgetDescription('refurb-progress')">
              Refurb in Progress
            </div>
          </div>
        </div>
        <div class="status-card" (click)="selectTile(['COMPLETED'])">
          <div class="inner-card">
            <div class="icon">
              <img src="{{ getStatusIconUrl('refurb-completed') }}" />
            </div>
            <div class="number">{{ overviewCounts?.refurbCompletedCount ?? 0 }}</div>
            <div class="label">Vehicles</div>
            <div class="status" [pTooltip]="getStatusWidgetDescription('refurb-completed')">
              Refurb Completed
            </div>
          </div>
        </div>
        <div class="status-card" (click)="selectTile(['RELEASED'])">
          <div class="inner-card">
            <div class="icon">
              <img src="{{ getStatusIconUrl('released') }}" />
            </div>
            <div class="number">{{ overviewCounts?.releasedCount ?? 0 }}</div>
            <div class="label">Vehicles</div>
            <div class="status" [pTooltip]="getStatusWidgetDescription('released')">Released</div>
          </div>
        </div>
      </div>
    </div>
    <div class="vehicle-sites-overview-container">
      <div class="site-container-heading">
        <h2>Your Sites</h2>
        <span class="site-view-action" (click)="showSiteDetails()">View Site Details</span>
      </div>
      <div class="site-overview-cards" *ngIf="siteStatusOverview">
        <div class="site-status-card" *ngFor="let site of siteStatusOverview">
          <div class="site-status-org-logo">
            <img [src]="site.providerLogoUrl" />
          </div>
          <div class="site-status-details">
            <div class="site-name">{{ site.providerName }}</div>
            <div class="site-total">{{ site.currentVehicleCount }} vehicles</div>
            <div class="site-capacity">Capacity: {{ site.maxCapacity }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="vehicle-status-details-container">
    <div class="vehicle-status-details-heading">
      <h2>Your Vehicles</h2>
    </div>
    <div>
      <form
        #form="ngForm"
        (ngSubmit)="search()"
        style="width: 100%"
        class="vehicle-status-details-filters style2023"
      >
        <div class="input-group">
          <div class="input-group-item">
            <i class="las la-search search-icon-resize"></i>
            <input
              pInputText
              name="searchReg"
              style="width: 170px"
              type="text"
              class="filter-group-input-container-right input-group-filter"
              placeholder="Search Reg."
              [(ngModel)]="this.filterVal.filters.vehicleReg.value"
            />
          </div>
        </div>
        <div class="input-group" style="width: 160px">
          <div class="input-group-item">
            <p-multiSelect
              [options]="customerSites"
              class="filter-dropdown input-group-filter"
              name="siteSelector"
              defaultLabel="All Sites"
              [(ngModel)]="this.filterVal.filters.sites.value"
            ></p-multiSelect>
          </div>
        </div>
        <div class="input-group" style="width: 160px">
          <div class="input-group-item">
            <p-multiSelect
              [options]="teams"
              class="filter-dropdown input-group-filter"
              name="teamSelector"
              defaultLabel="All Teams"
              [(ngModel)]="this.filterVal.filters.teams.value"
            ></p-multiSelect>
          </div>
        </div>
        <div class="input-group" style="width: 175px">
          <div class="input-group-item">
            <p-multiSelect
              [options]="refurbOptions"
              class="filter-dropdown input-group-filter"
              name="statusSelector"
              defaultLabel="All Statuses"
              [(ngModel)]="this.filterVal.filters.refurbStatuses.value"
              selectedItemsLabel="{0} Statuses Selected"
            ></p-multiSelect>
          </div>
        </div>
        <div class="input-group" style="width: 140px">
          <div class="input-group-item">
            <p-multiSelect
              [options]="vehicleMakes"
              class="filter-dropdown input-group-filter"
              name="makeSelector"
              defaultLabel="All Makes"
              [(ngModel)]="this.filterVal.filters.vehicleMakes.value"
              (ngModelChange)="onVehicleMakeChange()"
            ></p-multiSelect>
          </div>
        </div>
        <div class="input-group" style="width: 140px">
          <div class="input-group-item">
            <p-multiSelect
              [options]="vehicleModels"
              class="filter-dropdown input-group-filter"
              name="modelSelector"
              defaultLabel="All Models"
              [(ngModel)]="this.filterVal.filters.vehicleModels.value"
              [disabled]="this.vehicleModels.length == 0"
            ></p-multiSelect>
          </div>
        </div>
        <button
          pButton
          type="submit"
          class="button-style btn-md ui-primary-button"
          icon="fa ui-icon-search"
        ></button>
        <button
          pButton
          type="button"
          icon="fa ui-icon-restore"
          class="button-style btn-md ui-tertiary-button ml-1"
          (click)="resetFilters(dt)"
        ></button>
        <span class="vehicle-status-details-row-count" *ngIf="isLoaded"
          >{{ page.total }} Results</span
        >
      </form>
    </div>
    <div class="vehicle-status-details-header">Vehicle Status Details</div>
    <div class="vehicle-status-details-table">
      <p-table
        #dt
        [value]="page.items"
        [lazy]="true"
        [rows]="5"
        [first]="filterVal.first"
        [totalRecords]="page.total"
        [paginator]="true"
        [rowsPerPageOptions]="[5, 10, 20]"
        [pageLinks]="5"
        (onLazyLoad)="onGridLazyLoad($event)"
        [sortField]="filterVal.sortField"
        [sortOrder]="filterVal.sortOrder"
        [loading]="isLoading"
      >
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 140px" class="tb-align-left">Vehicle Reg, Make & Model</th>
            <th style="width: 140px">Current Order #</th>
            <th pSortableColumn="vehicleStatus" style="width: 180px">
              Vehicle Status <p-sortIcon field="vehicleStatus"></p-sortIcon>
            </th>
            <th class="tb-align-left">Previous Site</th>
            <th pSortableColumn="currentSite" class="tb-align-left">
              Current Site <p-sortIcon field="currentSite"></p-sortIcon>
            </th>
            <th pSortableColumn="timeStamp" class="tb-align-left" style="width: 230px">
              Current Site Duration <p-sortIcon field="timeStamp"></p-sortIcon>
            </th>
            <th pSortableColumn="team" style="width: 145px">
              Team <p-sortIcon field="team"></p-sortIcon>
            </th>
            <th style="width: 60px"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td style="font-weight: bold">
              <span style="font-weight: bold">{{ item.vehicleReg }}</span>
              <div class="vlc-vehicle-make">{{ item.vehicleMake }}</div>
              <div class="vlc-vehicle-model">{{ item.vehicleModel }}</div>
            </td>
            <td
              class="align-center"
              [ngClass]="{
                'order-ref-disabled': item.orderRef == 'N/A',
                'order-ref-clickable': item.orderRef != 'N/A'
              }"
              (click)="navigateToJobScreen(item.jobNumber, item.orderNumber)"
            >
              {{ item.orderRef }}
            </td>
            <td class="align-center">
              <div
                class="refurb-status-pill"
                [ngClass]="getPillClass(item.refurbStatus).class"
                [pTooltip]="getPillClass(item.refurbStatus).displayDescription"
                (click)="showOrderInfo(item)"
              >
                <i
                  class="fa fa-info-circle refurb-status-pill-i"
                  aria-hidden="true"
                  *ngIf="
                    item.refurbStatus == 'ENGINEIUS REQUESTED' || item.refurbStatus == 'ON ROUTE'
                  "
                ></i>
                {{ getPillClass(item.refurbStatus).displayLabel }}
              </div>
              <div class="vlc-status-last-update-time">
                Last Updated {{ timeSince(item.lastStatusUpdateTime) }} ago
              </div>
            </td>
            <td>{{ item.previousSite }}</td>
            <td>
              <div class="vlc-current-site-address">{{ item.currentSite }}</div>
              <div class="vlc-current-site-capacity">
                <span>{{ item.currentSiteCount }} vehicles at site</span>
                <i class="fa fa-circle vlc-current-site-capacity-separator" aria-hidden="true"></i>
                <span
                  >capacity:
                  {{ item.currentSiteCapacity > 0 ? item.currentSiteCapacity : 'N/A' }}</span
                >
              </div>
            </td>
            <td>
              <div [innerHTML]="convertMinutesToDaysHours(item.currentSiteDurationMins)"></div>
              <div class="vlc-current-site-arrival-time">
                Arrived {{ item.currentSiteArrivalTime | date : 'dd/MM/yyyy' }} at
                {{ item.currentSiteArrivalTime | date : 'hh:mm a' }}
              </div>
            </td>
            <td class="align-center">{{ item.teamName }}</td>
            <td>
              <button
                class="vlc-action-button"
                [pTooltip]="'Create new order for vehicle ' + item.vehicleReg"
                (click)="createOrder(item)"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr *ngIf="!isLoaded">
            <td colspan="8" style="text-align: center; padding-top: 20px; padding-bottom: 20px">
              Fetching the latest vehicle status details
              <br />
              <i
                class="fa fa-circle-o-notch fa-spin"
                aria-hidden="true"
                style="font-size: 15px; margin-top: 10px; color: #4c4c4c"
              ></i>
            </td>
          </tr>
          <tr *ngIf="isLoaded">
            <td colspan="9" style="text-align: center; padding-top: 20px; padding-bottom: 20px">
              No Vehicles Found
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-dialog
  header="Collection/Delivery Window Information"
  [(visible)]="orderInfoVisible"
  [modal]="true"
  [style]="{ width: '800px' }"
  [responsive]="true"
  (onHide)="hideOrderInfo()"
>
  <div class="vlc-additional-info-container" *ngIf="additionalOrderInfo">
    <div class="vlc-additional-info-left">
      <div class="col-12">
        <div class="vlc-pick-up-time-container">
          <div class="text-pick-up-colour font-bold">
            <i class="vme-material-icons">&#xe805;</i> Pick-up
          </div>

          <div class="vlc-additional-info-time-container">
            <div>
              <i class="vme-material-icons text-sm text-pick-up-colour">&#xe800;</i>
              Earliest Collection
            </div>
            <div class="font-bold text-gray-600">
              {{ additionalOrderInfo.earliestPickUpTime | datex : "ddd DD MMM 'YY" }}
              {{ additionalOrderInfo.earliestPickUpTime | datex : 'HH:mm' }}
            </div>
          </div>

          <div class="vlc-additional-info-time-container">
            <div>
              <i class="vme-material-icons text-sm text-pick-up-colour">&#xe800;</i>
              Latest Collection
            </div>

            <div class="font-bold text-gray-600">
              {{ additionalOrderInfo.latestPickUpTime | datex : "ddd DD MMM 'YY" }}
              {{ additionalOrderInfo.latestPickUpTime | datex : 'HH:mm' }}
            </div>
          </div>
        </div>
        <div class="vlc-drop-off-time-container">
          <div class="text-drop-off-colour font-bold">
            <i class="vme-material-icons">&#xe804;</i> Drop-off
          </div>

          <div class="vlc-additional-info-time-container">
            <div>
              <i class="vme-material-icons text-sm text-drop-off-colour">&#xe800;</i>
              Earliest Delivery
            </div>
            <div class="font-bold text-gray-600">
              {{ additionalOrderInfo.earliestDropOffTime | datex : "ddd DD MMM 'YY" }}
              {{ additionalOrderInfo.earliestDropOffTime | datex : 'HH:mm' }}
            </div>
          </div>

          <div class="vlc-additional-info-time-container">
            <div>
              <i class="vme-material-icons text-sm text-drop-off-colour">&#xe800;</i>
              Latest Delivery
            </div>

            <div class="font-bold text-gray-600">
              {{ additionalOrderInfo.latestDropOffTime | datex : "ddd DD MMM 'YY" }}
              {{ additionalOrderInfo.latestDropOffTime | datex : 'HH:mm' }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="vlc-additional-info-right">
      <a [href]="mapLink" target="_blank">
        <img
          [src]="mapLink"
          alt="Map"
          style="width: 100%; height: 100%"
          *ngIf="!mapLoading && mapLink && mapLink.length > 0"
        />
      </a>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Your Site Details"
  [(visible)]="siteDetailsVisible"
  [modal]="true"
  [style]="{ width: '1000px' }"
  [responsive]="true"
  (onHide)="hideSiteDetails()"
>
  <div class="vlc-site-details-container" *ngIf="groupedSiteDetails">
    <ng-container *ngFor="let provider of groupedSiteDetails | keyvalue">
      <h2>{{ provider.key }}</h2>
      <table>
        <thead>
          <tr>
            <th style="width: 60%">Address</th>
            <th>Vehicles on route</th>
            <th>Vehicles at site</th>
            <th>Site Capacity</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let site of getSiteDetailsForKey(provider.key)">
            <td style="width: 60%">
              <span class="site-name">{{ site.siteName }}</span> - {{ site.siteAddress }}
            </td>
            <td>{{ site.onRouteCount }} vehicles</td>
            <td>{{ site.onSiteCount }} vehicles</td>
            <td>{{ site.maxCapacity }} vehicles</td>
          </tr>
        </tbody>
      </table>
    </ng-container>
  </div>
</p-dialog>

<p-confirmDialog #cd [style]="{ width: '425px' }">
  <p-footer>
    <button type="button" pButton label="No" (click)="cd.reject()"></button>
    <button
      type="button"
      pButton
      class="ui-button ui-button-danger"
      label="Yes"
      (click)="cd.accept()"
    ></button>
  </p-footer>
</p-confirmDialog>
